const React = require('react');
const ScreenshotDesktop = require('./screenshotDesktop');
const ScreenshotMobile = require('./screenshotMobile');
const { useI18n } = require('nordic/i18n');
const { Button } = require('@andes/button');
const { useApiRefContextProvider } = require('../../../../../providers/apiRefContextProvider');
const { getEventTracker } = require('../../../../../utils/event-tracker');

const PostmanBanner = ({ deviceType }) => {
  const { i18n } = useI18n();
  const Tracker = getEventTracker();
  const isMobile = deviceType === 'mobile';
  const { postmanCollectionUrl } = useApiRefContextProvider();

  return (
    <div className="postman-banner">
      <div className="postman-banner__content">
        <h2>{i18n.gettext('Explora nuestra colección en Postman')}</h2>
        <p>{i18n.gettext('Postman es una herramienta que simplifica el desarrollo, las pruebas y la documentación de APIs, permitiendo crear y compartir solicitudes de manera rápida y segura.')}</p>
        <Button
          hierarchy="loud"
          onClick={() => {
            Tracker.send('mpdevelopers/api_ref/postman_cta/click');
          }}
          target="_blank"
          href={postmanCollectionUrl}
          fullWidth
        >
          {i18n.gettext('Explorar colección')}
        </Button>
      </div>
      {isMobile ? <ScreenshotMobile /> : <ScreenshotDesktop />}
    </div>
  );
};

module.exports = PostmanBanner;
